// ── Product tour bus ────────────────────────────────────────────────────────
// The sidebar publishes what it shows, and Settings and the menu under the
// staff member's name ask the tour to start. The tour itself is mounted once
// in the admin shell (routes/admin.tsx), like the copilot bubble and its bus
// (components/ai/copilotBus.ts).

import type { TourNode } from '@/lib/productTour'

let nav: TourNode[] = []
let navRole = ''

/** The sidebar's rows and groups as shown to this staff member, and their role. */
export function publishTourNav(next: TourNode[], role: string): void {
  nav = next
  navRole = role
}

export function tourNav(): { nav: TourNode[]; role: string } {
  return { nav, role: navRole }
}

type Listener = () => void

const listeners = new Set<Listener>()

export function startProductTour(): void {
  for (const l of listeners) l()
}

/** Subscribe to start requests; returns the unsubscribe. */
export function onStartTour(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
